import type { TextCellType } from '@/components';

// 基本的にmultiple内のtextCellに使う。
export const centerTextStyle: Omit<TextCellType, 'value'> = {
  wrapperStyle: { display: 'flex' },
  textWrapperStyle: { width: '100%' },
};
